import { CFIconGroupAccount } from './account';
import { CFIconGroupArrows } from './arrows';
import { CFIconGroupBusiness } from './business';
import { CFIconGroupCommunication } from './communication';
import { CFIconGroupControls } from './controls';
import { CFIconGroupCRNCustom } from './crn-custom';
import { CFIconGroupDevice } from './device';
import { CFIconGroupEdit } from './edit';
import { CFIconGroupFiles } from './files';
import { CFIconGroupHardware } from './hardware';
import { CFIconGroupImageAndVideo } from './image-and-video';
import { CFIconGroupInternetAndCode } from './internet-and-code';
import { CFIconGroupLogos } from './logos';
import { CFIconGroupMap } from './map';
import { CFIconGroupMenus } from './menus';
import { CFIconGroupMisc } from './misc';
import { CFIconGroupNotifications } from './notifications';
import { CFIconGroupPlayer } from './player';
import { CFIconGroupSecurity } from './security';
import { CFIconGroupShop } from './shop';
import { CFIconGroupSocial } from './social';
import { CFIconGroupTabs } from './tabs';
import { CFIconGroupView } from './view';
export * from './utilities';
export const CFBaseIcons = [
    ...CFIconGroupAccount,
    ...CFIconGroupArrows,
    ...CFIconGroupBusiness,
    ...CFIconGroupCRNCustom,
    ...CFIconGroupCommunication,
    ...CFIconGroupControls,
    ...CFIconGroupDevice,
    ...CFIconGroupEdit,
    ...CFIconGroupFiles,
    ...CFIconGroupHardware,
    ...CFIconGroupImageAndVideo,
    ...CFIconGroupInternetAndCode,
    ...CFIconGroupLogos,
    ...CFIconGroupMap,
    ...CFIconGroupMenus,
    ...CFIconGroupMisc,
    ...CFIconGroupNotifications,
    ...CFIconGroupPlayer,
    ...CFIconGroupSecurity,
    ...CFIconGroupShop,
    ...CFIconGroupSocial,
    ...CFIconGroupTabs,
    ...CFIconGroupView,
];
